module.exports = __webpack_public_path__ + "img/2_158.d965f5b1.png";